import * as types from '../../action/actionTypes';
import initialState from '../initialState';

export default function authServiceReducer(state = initialState.ASUBillingInvoices, action) {
    switch (action.type) {
        case types.GET_ASU_CAMPUS_INVOICES: return {
            ...state,AllCampusInvoices: action.getResponse,
        };
        case types.GET_CAMPUS_MONTHLYCHARGES: return {
            ...state,CampusMonthlyCharges: action.getResponse
        };
        case types.GET_ASU_CAMPUS_FILTERS: return {
            ...state,CampusBillingFilters: action.getResponse,
        };
        case types.GET_CAMPUS_BUILDING_INVOICE_BUILDINGID: return {
            ...state,CampusSelectedBuildingInvoice: action.getResponse,
        };
        case types.GET_BILLING_CALCULATION: return {
            ...state,BillingCalculations: action.getResponse,
        };
        default : return state; 
    }   
}